var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn-back",attrs:{"rounded":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("mdi-backspace-reverse-outline")]),_vm._v(" بازگشت ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }